/* eslint-disable @eslint-react/component-hook-factories */
import { type ComponentType } from 'react'
import { MfdContext } from '@/contexts'

export default function withMFD<P extends object>(WrappedComponent: ComponentType<P & { mfd: any; connected: any; settings: any }>) {
  return function ComponentWrapper(props: Omit<P, 'mfd' | 'connected' | 'settings'>) {
    return (
      <MfdContext.Consumer>
        {(mfdProps) => {
          const { mfd, connected, settings } = mfdProps as any
          return mfd ? (
            <WrappedComponent
              {...(props as P)}
              {...(mfdProps as any)}
              mfd={mfd}
              connected={connected}
              settings={settings}
            />
          ) : (
            null
          )
        }}
      </MfdContext.Consumer>
    )
  }
}
